/**
 * TEMPORARY. Delete once the action icon field is live in every environment.
 *
 * The icon is a field on the action now (WARP-569), served as `action.icon`.
 * This is the map the frontend used before that, kept only as a fallback for
 * the window where this frontend is deployed against an API that predates the
 * field. In that window `action.icon` is absent for every action, and without
 * this map the whole Action Needed column collapses to the generic icon.
 *
 * That window is not hypothetical: on WARP-838 the frontend shipped to Firebase
 * while the backend Fly deploy failed, leaving the frontend live against an
 * undeployed API. The two repos deploy separately and the backend deploy can
 * fail quietly.
 *
 * Two of these names never matched a real action, so they always fell through
 * to the generic icon. They are kept verbatim rather than corrected, because
 * the only job of this map is to reproduce the old behavior exactly. The
 * backend backfill has the corrected names.
 *
 * Cleanup ticket: WARP-934
 */
export const LEGACY_ACTION_ICONS_BY_NAME = {
  'Provide coverage explanation': 'paper-check',
  'Provide labor operation(s)': 'paper-check',
  'Provide approval code (PA)': 'code',
  'Upload/send supporting docs': 'upload',
  'Update customer complaint in DMS': 'person',
  'Provide valid customer complaint': 'person',
  'Update diagnostic code(s)/comments in DMS': 'memo-check',
  'Provide diagnostic code(s)/comments': 'memo-check',
  'Update factory defect comments in DMS': 'memo-check',
  'Provide factory defect comments': 'memo-check',
  'Update repair comments in DMS': 'memo-check',
  'Provide repair comments': 'memo-check',
  'Verify and provide correct mileage': 'mileage',
  'Add advisor/tech to MFG system': 'add',
  'Potential writeoff': 'paper',
  'Other - see problem notes': 'more',
  'Correct parts billed on RO': 'dollar',
  'Need management approval': 'id-badge',
  'Input customer payment method into DMS': 'dollar',
  'Provide approval code (PWA)': 'code',
  'Beyond submission time limit, contact MFG': 'clock',
  'Part chargeback, advise on appeal': 'receipt',
}

/**
 * Resolves the icon slug for an action.
 * @param {object} action an action from the API, with `icon` and `name`
 * @returns {string} the icon slug
 */
export const resolveActionIcon = (action) =>
  action?.icon || LEGACY_ACTION_ICONS_BY_NAME[action?.name] || 'more'
